module.exports = __webpack_public_path__ + "static/media/pencil.d07312d0.svg";